// https://app.zeplin.io/project/5eb47e6281606f752b9af017/screen/5f1b4de5fd4f6d39006a03e7
export const Radii = {
  xs: '2px',
  sm: '3px',
  base: '5px',
  lg: '8px',
  xl: '12px',
  xxl: '22.5px',
  circle: '50%',
  pill: '999px',
};
